import * as React from 'react'
import * as Common from '@tfo/common'
import classnames from 'classnames'

import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl'
import { Elements, ScrollView, Modal } from '@tfo/common'

import './AboutReportModal.scss'
import { Typography } from '@material-ui/core'

const {
	Heading3,
	Label,
	LabelSticker,
	ListItem,
	Paragraph,
	UnsortedList,
} = Elements

interface AboutReportModalProps {
	data: Common.models.ReportPackage
}
const AboutReportModal: React.FunctionComponent<Modal.ModalProps &
	WrappedComponentProps &
	AboutReportModalProps> = props => {
		const { onCloseClick, onDenyClick } = props
		const deliveryTextId =
			props.data.daysToDeliver < 2
				? 'neworder.caption.single'
				: 'neworder.caption.multiple'
		const bodyTextId = 'neworder.body.temporarilyEmpty'

		
		return (
			<Modal.Modal
				className={classnames('AboutReportModal')}
				onDenyClick={onDenyClick}
				onCloseClick={onCloseClick}
				large>
				<div className={'AboutReportModal__Inner'}>
					<div className='label-section'>
						<Label style={{ padding: '1rem 0' }}>{props.intl.formatMessage({ id: 'common.typeofreport' })}</Label>
						<LabelSticker style={{ padding: '1rem 0.5rem' }}>
							<FormattedMessage
								id={deliveryTextId}
								values={{ num: props.data.daysToDeliver }}
							/>
						</LabelSticker>
					</div>

					<div className={'AboutReportModal__Header'}>
						<Heading3 className="AboutReportModal__Heading4">
							{props.data.customName}
						</Heading3>
					</div>
					<div>
						<Paragraph>{props.data.description}</Paragraph>
					</div>
					<ScrollView>
						<div className={'AboutReportModal__ScrollingContent'}>
							<Paragraph small className="AboutReportModal__Paragraph">
								<FormattedMessage id={bodyTextId} />
							</Paragraph>
							<UnsortedList style={{marginBottom: '1rem'}}>
								{props.data.checkpoints.map(
									(checkpointId: string, index: number) => {
										return (
											<ListItem key={index}>
												<FormattedMessage
													id={'service.checkpoints.' + checkpointId}
												/>
											</ListItem>
										)
									},
								)}
							</UnsortedList>
							<Typography style={{color:'#616161'}} variant='caption'>{props.intl.formatMessage({ id: 'aboutbackgroundcheck.beforeProceeding'})}</Typography>
						</div>
					</ScrollView>
				</div>
			</Modal.Modal>
						 
		)
	}

export default injectIntl(AboutReportModal)
